import React, { useEffect, useState, useRef } from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useParams, Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import swal from "sweetalert";
import ListItemIcon from '@mui/material/ListItemIcon';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';
import PieChart from './Charts/PieChart';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useDeadline } from '../../../contexts/DeadlineContext';
import { useTheme } from '@mui/material/styles';
const approve = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '6px', transform: 'scale(2)', pl: 5 }}>
    <FactCheckIcon />
  </Box>
);
const pending = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '6px', transform: 'scale(2)', pl: 5 }}
  >
    <SwipeLeftIcon />
  </Box>
);
const reject = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '6px', transform: 'scale(2)', pl: 5 }}
  >
    <SwipeLeftIcon />
  </Box>
);
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}))


function createData(
  ids,
  name,
  calories,
  fat,
  carbs,
  protein,

) {
  return { ids, name, calories, fat, carbs, protein };
}
const rows = [
  createData(1, 'Frozen yoghurt', "Frozen@test.com", 123456,),
]





const WorkshopCollections = () => {




  const [abstractArticle, setAbstractArticle] = React.useState([]);
  const [paidCollection, setAllPaidCollection] = React.useState([]);

  const [totalReceiptCollection, setTotalReceiptCollection] = React.useState([]);
  const [totalBankCollection, setTotalBankCollection] = React.useState([]);
  const [totalCashCollection, setTotalCashCollection] = React.useState([]);
  const [totalOnlineCollection, setTotalOnlineCollection] = React.useState([]);


  const [paindingCollection, setPaindingCollection] = React.useState([]);
  const [totalParticipantCount, setTotalParticipantCount] = React.useState([]);
  const [totalMaleParticipantCount, setTotalMaleParticipantCount] = React.useState([]);
  const [totalFemaleParticipantCount, setTotalFemaleParticipantCount] = React.useState([]);


  const eventid = localStorage.getItem('eventid');
  const role = localStorage.getItem('role');
  const eventName = localStorage.getItem('eventname');


  const history = useHistory();
  const svgRef = useRef(null);
  const { abstractHomeSetup } = useDeadline();
  const gradientBackground = '#05597D';// Example gradient background
  const isSmallScreen = useMediaQuery('(max-width:600px)');


  useEffect(() => {
    axios.get(`api/get-workshop-collection?id=${eventid}`).then(res => {
      if (res.status === 200) {


        const totalReceipt = res.data.totalReceiptSum;
        setTotalReceiptCollection(totalReceipt);

        const totalBank = res.data.totalBankSum;
        setTotalBankCollection(totalBank);

        const totalcash = res.data.totalCashSum;
        setTotalCashCollection(totalcash);

        const totalonline = res.data.totalOnlineSum;
        setTotalOnlineCollection(totalonline)


      } else {
        swal('Error', "Check API Something Wrong", 'error');

      }
    })

  }, []);


  console.log("totalReceiptCollection", totalCashCollection)

  useEffect(() => {
    axios.get(`api/get-workshop-participnat-count?id=${eventid}`).then(res => {
      if (res.status === 200) {


        const totalParticipanCollections = res.data.totalParticipants;
        const maleParticipantCollections = res.data.maleParticipants;
        const femaleParticipantCollections = res.data.femaleParticipants;



        setTotalParticipantCount(totalParticipanCollections);
        setTotalMaleParticipantCount(maleParticipantCollections);
        setTotalFemaleParticipantCount(femaleParticipantCollections);




      } else {
        swal('Error', "Check API Something Wrong", 'error');

      }
    })

  }, []);


  return (
    <Box sx={{ padding: isSmallScreen ? 2 : 4, width: '100%' }} >
      <Grid container spacing={isSmallScreen ? 2 : 4}>
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ color: "purple", marginTop: isSmallScreen ? "20%" : "3%" }}>
          <Button sx={{
            float: 'right',
            marginTop: '0%',
            background: abstractHomeSetup.color_code_two || gradientBackground,
            ":hover": {
              color: "white"
            }
          }}
            color='success'
            size='small'
            variant='contained'

            onClick={() => history.goBack()} >
            Back
          </Button>
          <Item>
            <Typography variant={isSmallScreen ? "h5" : "h4"} gutterBottom>
              WorkShop Collection Dashboard
            </Typography>

          </Item>
        </Grid>
        <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
          <Item>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Total Participant
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {pending}. {totalParticipantCount}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Total Male Participant
                    </Typography>
                    <Typography variant="body2" variant="h2" color='secondary' key={1}>
                      {pending}. {totalMaleParticipantCount}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Total Female Participant
                    </Typography>
                    <Typography variant="body2" variant="h2" color="error.main" key={1}>
                      {pending}. {totalFemaleParticipantCount}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </Item>
        </Grid>

        <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
          <Item>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={3}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Bank Collection
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {pending}. {totalBankCollection}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={3}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Receipt Collection
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {pending}. {totalReceiptCollection}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={3}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Cash Collection
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {pending}. {totalCashCollection}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={3}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Typography variant="h5" component="div">
                      Online Collection
                    </Typography>
                    <Typography variant="body2" variant="h2" color="success.main" key={1}>
                      {pending}. {totalOnlineCollection}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </Item>
        </Grid>


      </Grid>
      
      <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
        <Item>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={4}>
              <Card sx={{ minWidth: 275 }}>
                <CardContent>
                  <PieChart
                    totalParticipantCount={totalParticipantCount}
                    totalMaleParticipantCount={totalMaleParticipantCount}
                    totalFemaleParticipantCount={totalFemaleParticipantCount}
                  />
                </CardContent>
                <CardActions>
                  <Button size="small" component={Link} to="#">
                    Learn More
                  </Button>
                </CardActions>
              </Card>
            </Grid>


          </Grid>
        </Item>
      </Grid>
      <hr></hr>
    </Box>
  )
}

export default WorkshopCollections;
